// Copyright 2023, mochabug AB
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.2.5 with parameter "target=ts,json_types=true,ts_nocheck=true"
// @generated from file mochabugapis/adapt/graph/jtd_schema.proto (package mochabugapis.adapt.graph, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import type { StructJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file mochabugapis/adapt/graph/jtd_schema.proto.
 */
export const file_mochabugapis_adapt_graph_jtd_schema: GenFile = /*@__PURE__*/
  fileDesc("Ciltb2NoYWJ1Z2FwaXMvYWRhcHQvZ3JhcGgvanRkX3NjaGVtYS5wcm90bxIYbW9jaGFidWdhcGlzLmFkYXB0LmdyYXBoIsEICglKVERTY2hlbWESSQoLZGVmaW5pdGlvbnMYASADKAsyNC5tb2NoYWJ1Z2FwaXMuYWRhcHQuZ3JhcGguSlREU2NoZW1hLkRlZmluaXRpb25zRW50cnkSLgoIbWV0YWRhdGEYAiABKAsyFy5nb29nbGUucHJvdG9idWYuU3RydWN0SACIAQESFQoIbnVsbGFibGUYAyABKAhIAYgBARIQCgNyZWYYBCABKAlIAogBARIRCgR0eXBlGAUgASgJSAOIAQESDAoEZW51bRgGIAMoCRI6CghlbGVtZW50cxgHIAEoCzIjLm1vY2hhYnVnYXBpcy5hZGFwdC5ncmFwaC5KVERTY2hlbWFIBIgBARJHCgpwcm9wZXJ0aWVzGAggAygLMjMubW9jaGFidWdhcGlzLmFkYXB0LmdyYXBoLkpURFNjaGVtYS5Qcm9wZXJ0aWVzRW50cnkSWAoTb3B0aW9uYWxfcHJvcGVydGllcxgJIAMoCzI7Lm1vY2hhYnVnYXBpcy5hZGFwdC5ncmFwaC5KVERTY2hlbWEuT3B0aW9uYWxQcm9wZXJ0aWVzRW50cnkSIgoVYWRkaXRpb25hbF9wcm9wZXJ0aWVzGAogASgISAWIAQESOAoGdmFsdWVzGAsgASgLMiMubW9jaGFidWdhcGlzLmFkYXB0LmdyYXBoLkpURFNjaGVtYUgGiAEBEhoKDWRpc2NyaW1pbmF0b3IYDCABKAlIB4gBARJBCgdtYXBwaW5nGA0gAygLMjAubW9jaGFidWdhcGlzLmFkYXB0LmdyYXBoLkpURFNjaGVtYS5NYXBwaW5nRW50cnkaVwoQRGVmaW5pdGlvbnNFbnRyeRILCgNrZXkYASABKAkSMgoFdmFsdWUYAiABKAsyIy5tb2NoYWJ1Z2FwaXMuYWRhcHQuZ3JhcGguSlREU2NoZW1hOgI4ARpWCg9Qcm9wZXJ0aWVzRW50cnkSCwoDa2V5GAEgASgJEjIKBXZhbHVlGAIgASgLMiMubW9jaGFidWdhcGlzLmFkYXB0LmdyYXBoLkpURFNjaGVtYToCOAEaXgoXT3B0aW9uYWxQcm9wZXJ0aWVzRW50cnkSCwoDa2V5GAEgASgJEjIKBXZhbHVlGAIgASgLMiMubW9jaGFidWdhcGlzLmFkYXB0LmdyYXBoLkpURFNjaGVtYToCOAEaUwoMTWFwcGluZ0VudHJ5EgsKA2tleRgBIAEoCRIyCgV2YWx1ZRgCIAEoCzIjLm1vY2hhYnVnYXBpcy5hZGFwdC5ncmFwaC5KVERTY2hlbWE6AjgBQgsKCV9tZXRhZGF0YUILCglfbnVsbGFibGVCBgoEX3JlZkIHCgVfdHlwZUILCglfZWxlbWVudHNCGAoWX2FkZGl0aW9uYWxfcHJvcGVydGllc0IJCgdfdmFsdWVzQhAKDl9kaXNjcmltaW5hdG9yYgZwcm90bzM", [file_google_protobuf_struct]);

/**
 * Schema represents a JSON Typedef Schema.
 *
 * @generated from message mochabugapis.adapt.graph.JTDSchema
 */
export type JTDSchema = Message<"mochabugapis.adapt.graph.JTDSchema"> & {
  /**
   * The definitions keyword MUST be an object where each value is a schema.
   * This object defines a collection of schema definitions that can be referenced via the ref keyword.
   *
   * @generated from field: map<string, mochabugapis.adapt.graph.JTDSchema> definitions = 1;
   */
  definitions: { [key: string]: JTDSchema };

  /**
   * The metadata keyword MUST be an object.
   * This object is ignored during validation and can store custom information about the schema.
   *
   * @generated from field: optional google.protobuf.Struct metadata = 2;
   */
  metadata?: JsonObject;

  /**
   * The nullable keyword MUST be a boolean.
   * If true, the schema matches the value null as well as any value matched by the rest of the schema.
   *
   * @generated from field: optional bool nullable = 3;
   */
  nullable?: boolean;

  /**
   * The ref keyword MUST be a string.
   * It is a reference to a schema defined in the definitions object.
   *
   * @generated from field: optional string ref = 4;
   */
  ref?: string;

  /**
   * The type keyword MUST be one of the predefined strings specifying the type of the value.
   * Valid values are: "boolean", "float32", "float64", "int8", "uint8", "int16", "uint16", "int32", "uint32", "string", "timestamp".
   *
   * @generated from field: optional string type = 5;
   */
  type?: string;

  /**
   * The enum keyword MUST be a non-empty array of strings.
   * The schema matches any value that is equal to one of the elements in the array.
   *
   * @generated from field: repeated string enum = 6;
   */
  enum: string[];

  /**
   * The elements keyword MUST be a schema.
   * It is used to validate elements in an array.
   *
   * @generated from field: optional mochabugapis.adapt.graph.JTDSchema elements = 7;
   */
  elements?: JTDSchema;

  /**
   * The properties keyword MUST be an object where each value is a schema.
   * Each key is a required property that must match the corresponding schema.
   *
   * @generated from field: map<string, mochabugapis.adapt.graph.JTDSchema> properties = 8;
   */
  properties: { [key: string]: JTDSchema };

  /**
   * The optional_properties keyword MUST be an object where each value is a schema.
   * Each key is an optional property that, if present, must match the corresponding schema.
   *
   * @generated from field: map<string, mochabugapis.adapt.graph.JTDSchema> optional_properties = 9;
   */
  optionalProperties: { [key: string]: JTDSchema };

  /**
   * The additional_properties keyword MUST be a boolean.
   * If true, the object may have properties other than those specified in properties and optionalProperties.
   *
   * @generated from field: optional bool additional_properties = 10;
   */
  additionalProperties?: boolean;

  /**
   * The values keyword MUST be a schema.
   * It is used to validate the values in an object.
   *
   * @generated from field: optional mochabugapis.adapt.graph.JTDSchema values = 11;
   */
  values?: JTDSchema;

  /**
   * The discriminator keyword MUST be a string.
   * It is used with mapping to represent tagged unions.
   *
   * @generated from field: optional string discriminator = 12;
   */
  discriminator?: string;

  /**
   * The mapping keyword MUST be an object where each value is a schema.
   * Used with discriminator for tagged unions, mapping discriminator values to schemas.
   *
   * @generated from field: map<string, mochabugapis.adapt.graph.JTDSchema> mapping = 13;
   */
  mapping: { [key: string]: JTDSchema };
};

/**
 * Schema represents a JSON Typedef Schema.
 *
 * @generated from message mochabugapis.adapt.graph.JTDSchema
 */
export type JTDSchemaJson = {
  /**
   * The definitions keyword MUST be an object where each value is a schema.
   * This object defines a collection of schema definitions that can be referenced via the ref keyword.
   *
   * @generated from field: map<string, mochabugapis.adapt.graph.JTDSchema> definitions = 1;
   */
  definitions?: { [key: string]: JTDSchemaJson };

  /**
   * The metadata keyword MUST be an object.
   * This object is ignored during validation and can store custom information about the schema.
   *
   * @generated from field: optional google.protobuf.Struct metadata = 2;
   */
  metadata?: StructJson;

  /**
   * The nullable keyword MUST be a boolean.
   * If true, the schema matches the value null as well as any value matched by the rest of the schema.
   *
   * @generated from field: optional bool nullable = 3;
   */
  nullable?: boolean;

  /**
   * The ref keyword MUST be a string.
   * It is a reference to a schema defined in the definitions object.
   *
   * @generated from field: optional string ref = 4;
   */
  ref?: string;

  /**
   * The type keyword MUST be one of the predefined strings specifying the type of the value.
   * Valid values are: "boolean", "float32", "float64", "int8", "uint8", "int16", "uint16", "int32", "uint32", "string", "timestamp".
   *
   * @generated from field: optional string type = 5;
   */
  type?: string;

  /**
   * The enum keyword MUST be a non-empty array of strings.
   * The schema matches any value that is equal to one of the elements in the array.
   *
   * @generated from field: repeated string enum = 6;
   */
  enum?: string[];

  /**
   * The elements keyword MUST be a schema.
   * It is used to validate elements in an array.
   *
   * @generated from field: optional mochabugapis.adapt.graph.JTDSchema elements = 7;
   */
  elements?: JTDSchemaJson;

  /**
   * The properties keyword MUST be an object where each value is a schema.
   * Each key is a required property that must match the corresponding schema.
   *
   * @generated from field: map<string, mochabugapis.adapt.graph.JTDSchema> properties = 8;
   */
  properties?: { [key: string]: JTDSchemaJson };

  /**
   * The optional_properties keyword MUST be an object where each value is a schema.
   * Each key is an optional property that, if present, must match the corresponding schema.
   *
   * @generated from field: map<string, mochabugapis.adapt.graph.JTDSchema> optional_properties = 9;
   */
  optionalProperties?: { [key: string]: JTDSchemaJson };

  /**
   * The additional_properties keyword MUST be a boolean.
   * If true, the object may have properties other than those specified in properties and optionalProperties.
   *
   * @generated from field: optional bool additional_properties = 10;
   */
  additionalProperties?: boolean;

  /**
   * The values keyword MUST be a schema.
   * It is used to validate the values in an object.
   *
   * @generated from field: optional mochabugapis.adapt.graph.JTDSchema values = 11;
   */
  values?: JTDSchemaJson;

  /**
   * The discriminator keyword MUST be a string.
   * It is used with mapping to represent tagged unions.
   *
   * @generated from field: optional string discriminator = 12;
   */
  discriminator?: string;

  /**
   * The mapping keyword MUST be an object where each value is a schema.
   * Used with discriminator for tagged unions, mapping discriminator values to schemas.
   *
   * @generated from field: map<string, mochabugapis.adapt.graph.JTDSchema> mapping = 13;
   */
  mapping?: { [key: string]: JTDSchemaJson };
};

/**
 * Describes the message mochabugapis.adapt.graph.JTDSchema.
 * Use `create(JTDSchemaSchema)` to create a new message.
 */
export const JTDSchemaSchema: GenMessage<JTDSchema, JTDSchemaJson> = /*@__PURE__*/
  messageDesc(file_mochabugapis_adapt_graph_jtd_schema, 0);

